import { render, staticRenderFns } from "./Year07.vue?vue&type=template&id=48d96b3d&scoped=true&"
import script from "./Year07.vue?vue&type=script&lang=js&"
export * from "./Year07.vue?vue&type=script&lang=js&"
import style0 from "./Year07.vue?vue&type=style&index=0&id=48d96b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d96b3d",
  null
  
)

export default component.exports